import { areas } from 'constants/workouts/targetAreas';
import { workoutFitnessLevelsTypes, workoutMethods } from 'constants/workouts/workouts';

export enum WorkoutPlanCategory {
    Main = 'main',
    Completed = 'completed',
    Additional = 'additional',
}

export type WorkoutResponse = {
    id: number;
    total_time: number;
    preview: string;
    method: workoutMethods;
    blocks: BlockType[];
    not_enough_content: boolean;
};

export type WorkoutType = WorkoutResponse & {
    created_at: string;
    planHash: string | null;
};

export type BlockExercise = {
    id: number;
    time: number;
    repetitions: number | null;
    target_area: string | null;
    type: number;
};

export type PlaylistExercise = BlockExercise & {
    playlistPosition: number;
};

export type WorkoutParamsType = {
    warm_up: boolean;
    cool_down: boolean;
    workout_time: number;
    workout_fitness_level: workoutFitnessLevelsTypes;
    debug_mode?: boolean;
    equipments: string[];
    target_areas: areas[];
    workout_type?: string;
    workout_method: workoutMethods;
    name?: string;
};

export type WorkoutBlocksType = {
    cool_down?: BlockType;
    warm_up?: BlockType;
    training: BlockType;
};

export type BlockType = {
    id: number;
    block_time: number;
    block_type: string;
    repetitions: number;
    required_unique_exercises: number;
    not_enough_content: boolean;
    exercises: BlockExercise[];
};

export type BuildWorkoutParamsType = {
    debug_mode: boolean;
    warm_up: boolean;
    cool_down: boolean;
    workout_time: number;
    workout_method: workoutMethods;
    workout_fitness_level: workoutFitnessLevelsTypes;
    equipments: string[];
    target_areas: areas;
};

export type WorkoutCompleteParamsType = {
    workout_id: number;
    calories_burned: number;
    time_spent: number;
    created_at: string;
    is_main_workout: boolean;
    challenge_id: number | null;
    challenge_position: number | null;
    exercise_data: Array<{ id: number; repetitions?: number; time: number }>;
};

export type WorkoutAudioType = {
    category_name: string;
    id: number;
    repetitions: number | null;
    text: string;
    time: number | null;
    updated_at: string;
    url: string;
};

export type WorkoutAudioMapType = {
    [key: string]: WorkoutAudioType[];
};

export type WorkoutPlanType = {
    all_equipment_prioritization: boolean;
    bmi_group: string | null;
    category: WorkoutPlanCategory;
    challenge_id: number;
    challenge_position: number;
    completion_id: number | null;
    cool_down: boolean;
    equipment_list: string[] | null;
    equipments: boolean;
    fitness_level: workoutFitnessLevelsTypes;
    hash: string | null;
    name: string;
    preview: string;
    target_areas: areas[];
    warm_up: boolean;
    workout_id: number | null;
    workout_method: workoutMethods;
    workout_preview: string;
    workout_time: number;
    workout_type: string;
};

export type WorkoutPlanResponse = {
    workouts: WorkoutPlanType[];
};
